// 소아고형암 온라인 자문시스템(OCSPST) 가상 카테고리
// 실제 카테고리가 아니라, 게시판 구분 없이 OCSPST 증례 링크가 걸린 게시글을 모아 보여주는 목록이다.
// portal 은 ?category=<key>, gallery 는 /post-list/<key> 로 들어온다.
export const OCSPST_CATEGORY = {
  key: "ocspst",
  name: "소아고형암 온라인 자문시스템",
} as const;
